import { StyleSheet } from 'aphrodite'

import transaction from './transaction'
import list from './list'
import status from './status'
import ColorBlind from './ColorBlind'

export default {
  list: StyleSheet.create(list),
  transaction: StyleSheet.create(transaction),
  status: StyleSheet.create(status),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Statistics/partials/BillingTable/style/index.js